import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaymentSettingsAdapter } from 'app/core/adapters/payment-settings.adapter';
import { PaymentSettings } from 'app/core/interfaces/payment-settings';
import { environment } from 'app/environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationSettingsService {
  constructor(
    private http: HttpClient,
    private paymentSettingsAdapter: PaymentSettingsAdapter,
  ) {}

  create(paymentSettings: PaymentSettings): Observable<PaymentSettings> {
    const paymentSettingsAPI = this.paymentSettingsAdapter.adaptToAPIFormat(paymentSettings);

    const payload: PaymentSettings = {
      ...paymentSettingsAPI,
      healthcare_plans: Array.isArray(paymentSettingsAPI.healthcare_plans) ? paymentSettingsAPI.healthcare_plans : [],
    };

    return this.http
      .post<PaymentSettings>(`${environment.apiUrl}/secretarias-settings`, payload)
      .pipe(map((paymentSettings: PaymentSettings) => this.paymentSettingsAdapter.adapterToModel(paymentSettings)));
  }

  createNew(paymentSettings: PaymentSettings): Observable<PaymentSettings> {
    const paymentSettingsAPI = this.paymentSettingsAdapter.adaptToAPIFormat(paymentSettings);

    const payload: PaymentSettings = {
      ...paymentSettingsAPI,
      healthcare_plans: Array.isArray(paymentSettingsAPI.healthcare_plans) ? paymentSettingsAPI.healthcare_plans : [],
    };

    return this.http
      .post<PaymentSettings>(`${environment.apiUrl}/secretarias-settings`, payload)
      .pipe(map((paymentSettings: PaymentSettings) => this.paymentSettingsAdapter.adapterToModel(paymentSettings)));
  }

  update(paymentSettings: PaymentSettings, payment_settings_id: string): Observable<PaymentSettings> {
    const paymentSettingsAPI = this.paymentSettingsAdapter.adaptToAPIFormat(paymentSettings);

    const payload: PaymentSettings = {
      ...paymentSettingsAPI,
      healthcare_plans: Array.isArray(paymentSettingsAPI.healthcare_plans) ? paymentSettingsAPI.healthcare_plans : [],
    };

    return this.http
      .put<PaymentSettings>(`${environment.apiUrl}/secretarias-settings/${payment_settings_id}`, payload)
      .pipe(map((paymentSettings: PaymentSettings) => this.paymentSettingsAdapter.adapterToModel(paymentSettings)));
  }

  updateNew(paymentSettings: PaymentSettings, payment_settings_id: string): Observable<PaymentSettings> {
    const paymentSettingsAPI = this.paymentSettingsAdapter.adaptToAPIFormat(paymentSettings);

    const payload: PaymentSettings = {
      ...paymentSettingsAPI,
      healthcare_plans: Array.isArray(paymentSettingsAPI.healthcare_plans) ? paymentSettingsAPI.healthcare_plans : [],
    };

    return this.http
      .put<PaymentSettings>(`${environment.apiUrl}/secretarias-settings/${payment_settings_id}`, payload)
      .pipe(map((paymentSettings: PaymentSettings) => this.paymentSettingsAdapter.adapterToModel(paymentSettings)));
  }

  findByOrganization(organization_id: string): Observable<PaymentSettings[]> {
    return this.http.get<PaymentSettings[] | PaymentSettings>(`${environment.apiUrl}/secretarias-settings/organizations/${organization_id}`).pipe(
      map((paymentSettingsAPI: PaymentSettings[] | PaymentSettings) => {
        const normalized = this.normalizeOrganizationSettingsResponse(paymentSettingsAPI);
        return normalized.map((paymentSettings: PaymentSettings) => this.paymentSettingsAdapter.adapterToModel(paymentSettings));
      }),
    );
  }

  createOnboarding(organization_id: string, recipient_id: string, payment_settings_id?: string): Observable<PaymentSettings['onboard_qrcode']> {
    return this.http.post<PaymentSettings['onboard_qrcode']>(
      `${environment.apiUrl}/secretarias-settings/organizations/${organization_id}/recipients/${recipient_id}`,
      { payment_settings_id },
    );
  }

  private normalizeOrganizationSettingsResponse(response: PaymentSettings[] | PaymentSettings): PaymentSettings[] {
    if (!Array.isArray(response)) {
      return response ? [response] : [];
    }

    const firstItem = response[0] as PaymentSettings | PaymentSettings[] | undefined;

    if (Array.isArray(firstItem)) {
      return firstItem;
    }

    return response;
  }
}
